import { AxiosResponse } from 'axios';
import { forbiddenStatus, okStatus } from 'utils/constants/api/statuses';

type Response = Pick<AxiosResponse, 'status' | 'headers' | 'data'>;

const CAPTCHA_MARKER = 'px-captcha';
const CAPTCHA_STATUSES = [okStatus, forbiddenStatus];

const isCaptchaChallenge = (response?: Response | null): boolean => {
  if (!response) {
    return false;
  }

  const contentType = response.headers?.['content-type'];

  if (typeof contentType !== 'string' || !contentType.toLowerCase().includes('text/html')) {
    return false;
  }

  if (!CAPTCHA_STATUSES.includes(response.status)) {
    return false;
  }

  return typeof response.data === 'string' && response.data.includes(CAPTCHA_MARKER);
};

export default isCaptchaChallenge;
